import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import NavLinks from './NavLinks';
import FarmfleetLogoMark from './FarmfleetLogoMark';
import './PublicHeader.css';

function PublicHeader({ onLoginClick }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="public-header">
      <div className="header-inner">
        <button
          type="button"
          className="header-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
        <Link to="/" className="logo" onClick={closeMenu}>
          <div className="logo-icon">
            <FarmfleetLogoMark />
          </div>
          <span className="logo-text">FARMFLEET</span>
        </Link>
        <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className="nav-logo" onClick={closeMenu}>
            <div className="nav-logo-icon">
              <FarmfleetLogoMark />
            </div>
            <span className="nav-logo-text">FARMFLEET</span>
          </Link>
          <button
            type="button"
            className="nav-close-btn"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
          <NavLinks onClick={closeMenu} />
        </nav>
        <button type="button" className="btn-login" onClick={onLoginClick}>LOGIN</button>
      </div>
      <div
        className={`header-overlay ${menuOpen ? 'active' : ''}`}
        onClick={closeMenu}
        onKeyDown={(e) => e.key === 'Escape' && closeMenu()}
        role="presentation"
        aria-hidden="true"
      />
    </header>
  );
}

export default PublicHeader;
